export const TYPE_TASK = "task";
export const TYPE_TODO = "todo";
export const TYPE_CIRCULAR = "circular";

const pad = (n) => String(n).padStart(2, "0");

export const dayKey = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const toDayKey = (value) => {
  if (!value) return "";
  if (value instanceof Date) return dayKey(value);
  const raw = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return raw.slice(0, 10);
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? "" : dayKey(d);
};

export const fmtEventTime = (value) => {
  if (!value) return "All day";
  const [h, m] = String(value).split(":");
  const hour = Number(h);
  if (Number.isNaN(hour)) return String(value);
  const suffix = hour >= 12 ? "PM" : "AM";
  return `${pad(hour % 12 === 0 ? 12 : hour % 12)}:${m || "00"} ${suffix}`;
};

const timeOf = (item, dateValue) => {
  const explicit = item.time || item.event_time || item.circular_time;
  if (explicit) return String(explicit).slice(0, 5);
  if (item.is_all_day || item.all_day) return "";
  const raw = String(dateValue || "");
  if (raw.includes("T")) {
    const d = new Date(raw);
    if (!Number.isNaN(d.getTime()))
      return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
  return "";
};

export const normalizeType = (value) => {
  const raw = String(value || "").toLowerCase();
  if (raw.includes("circ")) return TYPE_CIRCULAR;
  if (raw.includes("todo")) return TYPE_TODO;
  return TYPE_TASK;
};

export const readEventList = (res) => {
  if (Array.isArray(res)) return res;
  const candidates = [
    res?.items,
    res?.events,
    res?.data,
    res?.calendar,
    res?.results,
  ];
  return candidates.find(Array.isArray) || [];
};

export const normalizeEvent = (item, index) => {
  const dateValue =
    item.date ||
    item.event_date ||
    item.circular_date ||
    item.scheduled_at ||
    item.deadline ||
    item.due_date ||
    item.start_at ||
    item.start;
  const day = toDayKey(dateValue);
  if (!day) return null;
  const completed = Boolean(item.completed ?? item.is_completed);
  const time = timeOf(item, dateValue);
  const dueAt = time
    ? new Date(`${day}T${time}:00`)
    : new Date(`${day}T23:59:59`);
  return {
    id: `${item.type || item.event_type || "event"}-${item.id ?? index}-${day}`,
    rawId: item.id,
    type: normalizeType(
      item.type || item.event_type || item.kind || item.category,
    ),
    title: item.title || item.name || item.subject || "Untitled",
    description: item.description || item.message || "",
    day,
    time,
    completed,
    overdue: !completed && dueAt.getTime() < Date.now(),
    status: item.status || "",
    priority: String(item.priority || "").toLowerCase(),
    assignerName:
      item.assigner_name || item.assigned_by || item.created_by_name || "",
    assigneeName: item.assignee_name || item.assigned_to || "",
    assignee: item.assignee_name || item.assigned_to || item.creator_name || "",
    isRead: item.read ?? item.is_read,
  };
};

export const normalizeEvents = (res) =>
  readEventList(res).map(normalizeEvent).filter(Boolean);
